import { AppDomain } from '@ibk/shared-types';
export const INSIDE_SALES_TRIA_URL = 'https://vendas.dominiochat.com/';
export const INSIDE_SALES_SUPPORT_CENTRAL_BASE = 'https://suporte.dominioatendimento.com/central/faces/solucao.html';
export const INSIDE_SALES_FAQ_PORTAL_URL_BY_DOMAIN = {
    [AppDomain.ESCRITORIO]: `${INSIDE_SALES_SUPPORT_CENTRAL_BASE}?codigo=12818`,
    [AppDomain.EMPRESA]: `${INSIDE_SALES_SUPPORT_CENTRAL_BASE}?codigo=12814`,
};
export const INSIDE_SALES_FAQ_SAIBA_MAIS_URL_BY_DOMAIN_AND_ITEM = {
    [AppDomain.ESCRITORIO]: {
        '0': `${INSIDE_SALES_SUPPORT_CENTRAL_BASE}?codigo=10800&palavraChave=Dom%C3%ADnio%20Benef%C3%ADcios&modulosSelecionados=0&intencaoID=0`,
        '8': `${INSIDE_SALES_SUPPORT_CENTRAL_BASE}?codigo=11330&palavraChave=Dom%C3%ADnio%20Benef%C3%ADcios%20convidar&modulosSelecionados=0&intencaoID=0`,
    },
    [AppDomain.EMPRESA]: {
        '0': `${INSIDE_SALES_SUPPORT_CENTRAL_BASE}?codigo=10800&palavraChave=Dom%C3%ADnio%20Benef%C3%ADcios&modulosSelecionados=0&intencaoID=0`,
    },
};
export const INSIDE_SALES_SUPERAPP_DEEPLINK = {
    [AppDomain.ESCRITORIO]: 'https://contabil.dominiosistemas.com.br/deeplink?module=home',
    [AppDomain.EMPRESA]: 'https://empresas.dominiosistemas.com.br/deeplink?module=home',
};
export const INSIDE_SALES_STORE_URLS = {
    [AppDomain.ESCRITORIO]: {
        android: 'https://play.google.com/store/apps/details?id=com.thomsonreuters.domino.accountant',
        ios: 'https://apps.apple.com/br/app/dom%C3%ADnio-escrit%C3%B3rio/id6468593700',
    },
    [AppDomain.EMPRESA]: {
        android: 'https://play.google.com/store/apps/details?id=com.thomsonreuters.domino.client',
        ios: 'https://apps.apple.com/br/app/dominio-empresa/id6468593687',
    },
};
